import { jsx as _jsx } from "react/jsx-runtime";
import Label from '../Label';
const Legend = props => /*#__PURE__*/_jsx(Label, {
  as: "legend",
  "data-mesh-component": "FORM-CONTROL--LEGEND",
  ...props
});
export default Legend;